import type { BoxProps } from 'rebass/styled-components';

import { mediumBreakpoint } from '../../../../utils/breakpoints';
import { chunkArray } from '../../../../utils/common';
import { useCurrentBreakpoint } from '../../../../utils/hooks/breakpoints';
import { ProductCard, type ProductCardProps, withErrorBoundary } from '../../../components';

import { StyledCardsWrapper, StyledHorizontalProductWrapper } from './Styled';

interface HorizontalProps extends BoxProps {
  products: ProductCardProps[];
  variant: 'horizontalLeft' | 'horizontalRight';
}

const Horizontal = ({ products, variant }: HorizontalProps) => {
  const currentBreakpoint = useCurrentBreakpoint();
  const chunkedProducts = chunkArray(products, 2);

  return (
    <>
      {chunkedProducts.map(({ chunk, key }) => {
        const chunkHasPriceOrEnquiry: boolean = chunk.reduce((acc, { price, enquiryCta }) => {
          if (acc === true) {
            return true;
          }
          if (price || enquiryCta) {
            return true;
          }

          return false;
        }, false);

        return (
          <StyledCardsWrapper key={key} className={`cards-${chunk.length}`}>
            {chunk.map(({ id, ...productRest }) => (
              <StyledHorizontalProductWrapper key={id} className={`cards-${chunk.length}`}>
                <ProductCard
                  id={id}
                  variant={variant}
                  showCommerceSection={currentBreakpoint === mediumBreakpoint ? chunkHasPriceOrEnquiry : false}
                  {...productRest}
                />
              </StyledHorizontalProductWrapper>
            ))}
          </StyledCardsWrapper>
        );
      })}
    </>
  );
};

export default withErrorBoundary(Horizontal, { componentName: 'ProductListingModule/Horizontal' });
